import { WithdrawalsDestinationDTO } from '../../request-withdrawal/request-withdrawal.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AcceptWithdrawalService } from '../accept-withdrawal.service';

@Component({
  selector: 'accept-withdrawal',
  templateUrl: './accept-withdrawal.component.html',
  styleUrls: ['./accept-withdrawal.component.scss'],
  standalone: false,
})
export class AcceptWithdrawalComponent implements OnInit {
  private playerId: number;
  private cardId: number;
  private paymentId: number;
  private amount: number;

  checkedEntriesCount: number;

  selectedDestination: WithdrawalsDestinationDTO;

  isClosedLoopMaxExceeded: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AcceptWithdrawalComponent>,
    private acceptWithdrawalService: AcceptWithdrawalService
  ) {
    this.checkedEntriesCount = data.checkedEntriesCount;
    this.playerId = data.playerId;
    this.cardId = data.cardId;
    this.paymentId = data.paymentId;
    this.amount = data.amount;
  }

  ngOnInit(): void {
    this.setSelectedWithdrawalDestination();
  }

  setSelectedWithdrawalDestination() {
    this.acceptWithdrawalService.getSelectedWithdrawalDestination(this.playerId, this.paymentId, this.cardId).subscribe(
      (destination) => {
        if (destination) {
          this.selectedDestination = destination;
          this.isClosedLoopMaxExceeded = this.checkClosedLoopMaxExceeded();
        }
      },
      (err) => {
        console.error(`Error setting withdrawal destination for player ${this.playerId}.`, err);
      }
    );
  }

  checkClosedLoopMaxExceeded(): boolean {
    const destination = this.selectedDestination;

    if (destination !== undefined && destination?.closedLoopRestricted) {
      const amount: number = this.amount;
      const closedLoopMax = this.parseAmount(destination?.closedLoopMaximum);

      if (amount !== undefined && amount > closedLoopMax) {
        return true;
      }
    }
    return false;
  }

  parseAmount(value: string): number {
    if (value === undefined) {
      return undefined;
    }

    let amountStr: string = value;
    amountStr = amountStr.substring(3);
    amountStr = amountStr.trim();
    return Number.parseFloat(amountStr);
  }

  getSelectedWithdrawalDestinationText(): string {
    let value = '';
    const destination = this.selectedDestination;
    if (destination !== null && destination !== undefined) {
      value = destination?.id + ' - ' + destination?.name;
      if (destination?.cardLastFour !== undefined) {
        value = value + ' - x' + destination?.cardLastFour;
      }
      if (destination?.cardExpiryDate !== undefined) {
        value = value + ' - ' + destination?.cardExpiryDate;
      }
    }
    return value;
  }

  acceptWithdrawal() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
